import React from "react";
import { useEditor, EditorContent } from "@tiptap/react";

import EditorToolbar from "./EditorToolbar";
import { getBaseExtensions } from "./extensions";
import { StyledStackV2, StyledToolbarV2, StyledDocumentArea } from "./styles";

const HubEditorV2 = ({
  placeholder = "Start editing document...",
  onChange,
  value = "",
  users = [],
  ...rest
}) => {
  const extensions = getBaseExtensions({ placeholder });

  const editor = useEditor({
    extensions,
    content: value || "",
    onUpdate: ({ editor }) => {
      onChange && onChange(editor.getJSON());
    },
  });

  return (
    <StyledStackV2>
      <StyledToolbarV2>
        <EditorToolbar editor={editor} />
      </StyledToolbarV2>
      <StyledDocumentArea>
        <EditorContent editor={editor} />
      </StyledDocumentArea>
    </StyledStackV2>
  );
};

export default HubEditorV2;
